import React, { createContext, useState, useCallback, useMemo } from 'react';

export const ModalStackContext = createContext(null);

export const ModalStackProvider = ({ children }) => {
    const [stack, setStack] = useState([]);

    const pushModal = useCallback((id) => {
        setStack((prev) => [...prev, id]);
    }, []);

    const popModal = useCallback((id) => {
        setStack((prev) => prev.filter((elem) => elem !== id));
    }, []);

    const value = useMemo(() => {
        return {
            stack,
            pushModal,
            popModal,
        };
    }, [stack, pushModal, popModal]);

    return (
        <ModalStackContext.Provider value={value}>
            {children}
        </ModalStackContext.Provider>
    );
};
